import Component from "@bythepixel/component-loader";

export default class BlogIndexLoadMoreButton extends Component {
  static selector = "[data-comp-blog-index-load-more-button]";
  static loaderPriority = "in-view";

  constructor(containerEl) {
    super(containerEl);
    this.postsContainer = document.querySelector("[data-posts-container]");
    this.categoryId = this.$container.hasAttribute("data-category-id")
      ? this.$container.getAttribute("data-category-id")
      : null;
    this.postsPerPage = this.$container.dataset.postsPerPage;
    this.offset = 1;
    this.addClickListener();
  }

  addClickListener() {
    this.$container.addEventListener("click", () => {
      let loadMorePath = `/blog/more/${this.offset * this.postsPerPage}`;

      if (this.categoryId != null) {
        loadMorePath = `${loadMorePath}/${this.categoryId}`;
      }

      fetch(loadMorePath, {
        method: "get",
      })
        .then((response) => response.json())
        .then((jsonData) => this.appendPosts(jsonData))
        .catch((err) => {
          console.log(err);
        });
    });
  }

  appendPosts(jsonData) {
    const postsGrid = document.createElement("div");
    postsGrid.classList.add("posts-grid");
    postsGrid.innerHTML = jsonData.html;
    this.postsContainer.append(postsGrid);

    this.offset += 1;

    if (jsonData.morePosts !== true) {
      this.$container.style.display = "none";
    }
  }
}
